import 'extensions/ui-components/x-slick-slider';
import {html, LitElement} from 'lit';
import {ref, createRef} from 'lit/directives/ref.js';
import {MutationController} from 'extensions/ui-controllers';
import {defineCustomElement} from 'extensions/utils';

export class Carousel extends LitElement {
	static get properties () {
		return {
			disableArrows: {
				attribute: 'disable-arrows',
				type: Boolean
			},
			disableInfinite: {
				attribute: 'disable-infinite',
				type: Boolean
			},
			dots: {
				type: Boolean
			},
			slidesPerScroll: {
				attribute: 'slides-per-scroll',
				type: Number
			},
			slidesPerView: {
				attribute: 'slides-per-view',
				type: Number
			}
		};
	}

	sliderRef = createRef();

	/**
	 * @type {JQuerySlickOptions}
	 */
	get sliderOptions () {
		return {
			arrows: !this.disableArrows,
			dots: this.dots,
			draggable: true,
			infinite: !this.disableInfinite,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						slidesToScroll: Math.ceil(this.slidesPerScroll / 3),
						slidesToShow: Math.ceil(this.slidesPerView / 3)
					}
				},
				{
					breakpoint: 900,
					settings: {
						slidesToScroll: Math.ceil(this.slidesPerScroll / 2),
						slidesToShow: Math.ceil(this.slidesPerView / 2)
					}
				},
				{
					breakpoint: 1300,
					settings: {
						slidesToScroll: Math.ceil(this.slidesPerScroll / 1.5),
						slidesToShow: Math.ceil(this.slidesPerView / 1.5)
					}
				}
			],
			slidesToScroll: this.slidesPerScroll,
			slidesToShow: this.slidesPerView
		};
	}

	constructor () {
		super();

		this.disableArrows = false;
		this.disableInfinite = false;
		this.dots = false;
		this.slidesPerView = 5;
		this.slidesPerScroll = 5;

		// Mutation observer
		this.mutationController = new MutationController(this, {
			attributes: false,
			childList: true,
			subtree: true
		});
	}

	updated () {
		if (typeof this.sliderRef?.value?.requestUpdate === 'function') {
			this.sliderRef?.value?.requestUpdate();
		}
	}

	renderSlides () {
		return html`<slot></slot>`;
	}

	render () {
		return html`
			<x-slick-slider ${ref(this.sliderRef)} .options="${this.sliderOptions}">
				${this.renderSlides()}
			</x-slick-slider>
		`;
	}
};

defineCustomElement('x-carousel', Carousel);
